const StartAgain = () => {
    const handleClick = () => {
        window.location.reload()
    }

    return (
        <div className="cursor-pointer text-[14px] underline underline-offset-2" onClick={handleClick}>
            RESET CHAT
        </div>
    )
}

export default StartAgain
